import {
    Component,
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    OnDestroy,
    OnInit,
    ViewEncapsulation
} from '@angular/core';
import { FEATURE } from '@core/auth/feature-id';
import { NAVIGATION_MENU_ITEMS } from './navigation-menu-items';
import { NavigationMenuItem } from './navigation-menu-item';
import { StateMatchType } from '@shared/directives/state-ref/state-match-type';
import { AuthService } from '@core/state/auth/auth.service';
import { filter, Subject, takeUntil } from 'rxjs';
import { RouterService } from '@core/state/router/router.service';
import { BillingService } from '@core/state/billing/billing.service';
import { SessionService } from '@core/state/session/session.service';
import { IAppRouterState } from '@core/state/router/router-state';
import { AccountRole } from '@core/models/account/account-role';
import { Company } from '@core/models/common/company';
import { User } from '@core/models/user/user';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { StateRefDirective } from '@shared/directives/state-ref/state-ref.directive';
import { ElementsModule } from '@shared/elements/elements.module';

@Component({
    selector: 'pay-navigation-menu',
    templateUrl: './navigation-menu.component.html',
    styleUrls: [
      './navigation-menu.component.scss'
    ],
    imports: [
      CommonModule,
      TranslateModule,
      StateRefDirective,
      ElementsModule
    ],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
      class: 'c-navigation-menu'
    }
})
export class NavigationMenuComponent implements OnInit, OnDestroy {

    public readonly FEATURE = FEATURE;

    public items: NavigationMenuItem[] = NAVIGATION_MENU_ITEMS;
    public STATE_STARTS_WITH: StateMatchType = StateMatchType.STARTS_WITH;
    public showNavigationMenu: boolean = true;
    public isDevSupport: boolean;
    public isAdmin: boolean;
    public isManager: boolean;
    public user: User;
    public company: Company;
    public accordionStatus: boolean[];

    private destroyed$: Subject<void> = new Subject();
    
    constructor(private cdr: ChangeDetectorRef,
                private authService: AuthService,
                private routerService: RouterService,
                private billingService: BillingService,
                private sessionService: SessionService) {

        this.accordionStatus = this.items
            .map((item: NavigationMenuItem) => false);
    }

    ngOnInit() {
        this.routerService.getCurrentState()
            .pipe(
                filter((appRouterState: IAppRouterState) => appRouterState.name?.length > 0),
                takeUntil(this.destroyed$)
            )
            .subscribe((appRouterState: IAppRouterState) => {
                this.items.forEach((item: NavigationMenuItem, index: number) => {
                    if (item.items?.length) {
                        item.items.forEach((subItem: NavigationMenuItem, subIndex: number) => {
                            if (appRouterState.name.indexOf(subItem.state) === 0) {
                                this.accordionStatus[index] = true;
                            }
                        });
                    }
                });

                this.cdr.markForCheck();
            });

        this.sessionService.getCompany()
            .pipe(takeUntil(this.destroyed$))
            .subscribe((company: Company) => {
                this.isAdmin = company?.role === AccountRole.ADMIN;
                this.isManager = company?.role === AccountRole.MANAGER;
                this.cdr.markForCheck();
            });

            this.sessionService.getUser()
            .pipe(takeUntil(this.destroyed$))
            .subscribe((user: User) => {
                this.user = user;
                this.cdr.markForCheck();
            });
    }

    ngOnDestroy() {
        this.destroyed$.next();
    }

    goTo(state: string) {
        this.routerService.go(state, null, { reload: true });
    }

    clickMenuItem(item: NavigationMenuItem, index: number, event: Event) {

        this.accordionStatus.forEach((status: boolean, otherIndex: number) => {
            if (otherIndex !== index) {
                this.accordionStatus[otherIndex] = false;
                this.cdr.detectChanges();
            }
        });
        
        if (item.items?.length) {
            event.stopPropagation();
            event.preventDefault();

            

            this.accordionStatus[index] = !this.accordionStatus[index];
            this.cdr.markForCheck();
        } else {
            

            this.goTo(item.state);
        }
    }
}
